export function InchesToFeetAndInches(totalInches) {
  const feet = Math.floor(totalInches / 12); // Calculate the whole number of feet
  const inches = totalInches % 12; // Calculate the remaining inches
  return `${feet}' ${inches}"`;
}
